import { render } from "./EmailTemplateIndexComponent.vue?vue&type=template&id=74af99e8"
import script from "./EmailTemplateIndexComponent.vue?vue&type=script&lang=js"
export * from "./EmailTemplateIndexComponent.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__